"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2146],{

/***/ 48:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ LOCAL_STORAGE_JOBS_SEARCH_HISTORY; }
/* harmony export */ });
/* unused harmony export LOCAL_STORAGE_AINO_PREVENT_POPUP_KEY */
var LOCAL_STORAGE_AINO_PREVENT_POPUP_KEY = "wif_aino_prevent_chatPanel_Popup";
var LOCAL_STORAGE_JOBS_SEARCH_HISTORY = "wif-jobs-search-history";


/***/ }),

/***/ 2670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XO": function() { return /* binding */ getJobsPageSize; },
/* harmony export */   "gN": function() { return /* binding */ JOBS_PREVIEW_COUNT; },
/* harmony export */   "hZ": function() { return /* binding */ parseJobsPage; },
/* harmony export */   "iR": function() { return /* binding */ clampJobsPage; },
/* harmony export */   "pm": function() { return /* binding */ JOBS_PAGE_SIZE; }
/* harmony export */ });
/* unused harmony exports JOBS_MOBILE_PAGE_SIZE, getJobsRange */
var JOBS_PAGE_SIZE = 12;
var JOBS_MOBILE_PAGE_SIZE = 6;
var JOBS_PREVIEW_COUNT = 6;
function getJobsPageSize(isMobile) {
    return isMobile ? JOBS_MOBILE_PAGE_SIZE : JOBS_PAGE_SIZE;
}
/** Reads the `page` query param, falling back to the first page. */ function parseJobsPage(value) {
    var page = Number(value);
    if (!Number.isFinite(page) || page < 1) {
        return 1;
    }
    return Math.floor(page);
}
/** Pages past the last result page fall back to the first page. */ function clampJobsPage(page, totalPages) {
    if (totalPages > 0 && page > totalPages) {
        return 1;
    }
    return page;
}
function getJobsRange(page, pageSize, visibleCount, total) {
    var from = (page - 1) * pageSize + 1;
    if (total <= 0 || from > total) {
        return {
            from: 0,
            to: 0
        };
    }
    var to = Math.min((page - 1) * pageSize + visibleCount, total);
    return {
        from: from,
        to: to
    };
}


/***/ }),

/***/ 7025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Ct; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3406);
/* harmony import */ var _PageHeader_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9792);
/* harmony import */ var _Dropdown_cd8b285a_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8501);
/* harmony import */ var _index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8517);
/* harmony import */ var _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3355);
/* harmony import */ var _useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8643);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4877);
/* harmony import */ var _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7977);









const ce = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(void 0);
function C() {
  const t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ce);
  if (!t)
    throw new Error(
      "TypeAheadRefsContext should be only used inside TypeAhead component."
    );
  return t;
}
function ee(t) {
  const o = "type-ahead";
  return (...a) => ({
    id: [o, t, ...a].join("-"),
    "data-testid": [o, ...a].join("-")
  });
}
function oe(t) {
  return t?.querySelectorAll("[tabindex]");
}
function I(t) {
  return typeof t == "string" ? {
    label: t,
    value: t
  } : {
    value: t.value,
    label: t.label || t.value
  };
}
const xe = "visually-hidden", ve = "type-ahead", Ee = "type-ahead__input", Fe = "type-ahead__input--expanded", ge = "type-ahead__input--input-field", Ie = "type-ahead__input--clear-button", Ae = "type-ahead__list-box", Ce = "type-ahead__list-box-item", He = "type-ahead__list-box-item--heading", Be = "type-ahead__list-box-item--action", we = "type-ahead__list-box-item--action-type", _e = "type-ahead__list-box-loading", v = {
  visuallyHidden: xe,
  typeAhead: ve,
  typeAheadInput: Ee,
  typeAheadInputExpanded: Fe,
  typeAheadInputInputField: ge,
  typeAheadInputClearButton: Ie,
  typeAheadListBox: Ae,
  typeAheadListBoxItem: Ce,
  typeAheadListBoxItemHeading: He,
  typeAheadListBoxItemAction: Be,
  typeAheadListBoxItemActionType: we,
  typeAheadListBoxLoading: _e
};
function Te(t, o) {
  const { className: a, onChange: r, onClear: s, ...l } = t, { isListBoxOpen: i } = C(), { uuid: c } = C(), n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), h = t.value.length > 0, d = ee(c), u = d("input"), p = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (m) => r(m.currentTarget.value),
    [r]
  ), y = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    h && (r(""), s?.()), n.current?.focus();
  }, [h, r, s]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      ...d("input-container"),
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        v.typeAheadInput,
        i && v.typeAheadInputExpanded
      )
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "input",
      {
        ...u,
        ...l,
        id: l.id || u.id,
        ref: (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(o, n),
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
          a,
          v.typeAheadInputInputField,
          _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsLeadText
        ),
        onChange: p,
        role: "combobox",
        autoComplete: "off",
        "aria-expanded": i,
        "aria-haspopup": "listbox",
        "aria-autocomplete": "list",
        "aria-controls": d("list").id
      }
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "button",
      {
        ...d("input-icon-button"),
        className: v.typeAheadInputClearButton,
        "aria-label": h ? "Search Close" : "Search",
        onClick: y
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__.I, { icon: h ? _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__.W.CLOSE : _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__.W.SEARCH, size: 20 })
    )
  );
}
const Se = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Te);
function Ne(t, o) {
  const a = ee(t.uuid);
  if (t.variant === "heading")
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "button",
      {
        ...a("list-item", t.variant),
        ref: o,
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
          v.typeAheadListBoxItem,
          v.typeAheadListBoxItemHeading
        ),
        disabled: !0
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsLeadText }, t.value)
    );
  const { label: r } = I(t.option);
  return t.variant === "action" && t.prefixText === "" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      ...a("list-item", t.variant),
      ref: o,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        v.typeAheadListBoxItem,
        t.variant === "action" && v.typeAheadListBoxItemAction
      ),
      onClick: () => t.onClick(t.option),
      tabIndex: -1,
      role: "option"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__.I,
      {
        icon: t.variant === "history" ? _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__.W.CLOCK : _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__.W.SEARCH,
        size: 16
      }
    ),
    t.variant === "action" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsLeadTextBold }, t.prefixText, " ", `"${r}"`) : t.variant === "autocomplete" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Oe, { ...t }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsLeadText }, r)
  );
}
const k = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Ne);
function Oe({
  option: t,
  latestWord: o,
  isFirstWord: a
}) {
  const { label: r } = I(t), { type: s } = t, { isNewJobsHeader: l } = C(), i = l ? r : o ? r.toLowerCase().split(o.trim().toLowerCase()).slice(1) : r;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsLeadText }, a ? "" : "...", typeof i == "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, i) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("strong", null, o), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, i.join("")))), s ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsCaption,
        v.typeAheadListBoxItemActionType
      )
    },
    "•  ",
    s
  ) : null);
}
function We({
  i18n: t,
  autocompleteSuggestions: o,
  changeSearchValue: a
}) {
  const {
    firstListBoxItemRef: r,
    lastListBoxItemRef: s,
    searchValue: l,
    currentWord: i,
    uuid: c,
    isNewJobsHeader: n
  } = C(), h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (m) => {
      const { value: b } = I(m);
      if (n)
        a(b + " ", !1);
      else {
        const j = l.split(" ").map((L) => L === i ? b : L).join(" ");
        a(j + " ", !1);
      }
    },
    [a, l, i, n]
  ), d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (m) => {
      const { value: b } = I(m);
      a(b, !0);
    },
    [a]
  ), u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (n)
      return o;
    const m = i.trim().toLowerCase();
    return m ? o.filter((b) => {
      const { value: j } = I(b);
      return j.trim().toLowerCase().startsWith(m);
    }) : [];
  }, [o, i, n]), { isLoading: p } = C(), y = n ? "No results found. Please use another job title." : "No results found";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, p ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "span",
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsLeadText,
        v.typeAheadListBoxLoading
      )
    },
    "Loading…"
  ) : u.length ? u.map((m, b) => {
    const { value: j } = I(m), { type: L } = m, H = n ? !0 : l.split(" ").length === 1;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      k,
      {
        key: j + L,
        uuid: c + b,
        variant: "autocomplete",
        option: m,
        latestWord: i,
        isFirstWord: H,
        onClick: h,
        ref: b === 0 ? r : void 0
      }
    );
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "span",
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsLeadText,
        v.typeAheadListBoxLoading
      )
    },
    y
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    k,
    {
      uuid: c,
      variant: "action",
      option: l,
      prefixText: n ? "" : t?.searchFor || "Search for",
      onClick: d,
      ref: (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(
        s,
        o.length === 0 ? r : void 0
      )
    }
  ));
}
function Re({
  searchHistory: t = [],
  i18n: o,
  onClick: a
}) {
  const { firstListBoxItemRef: r, lastListBoxItemRef: s, uuid: l } = C();
  return t.length === 0 ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    k,
    {
      uuid: l,
      variant: "heading",
      value: o?.searchHistory || "Search history"
    }
  ), t.slice(0, 2).map((i, c) => {
    const { value: n } = I(i);
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      k,
      {
        uuid: l + c,
        key: n,
        option: i,
        variant: "history",
        onClick: a,
        ref: (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(
          c === 0 ? r : void 0,
          s
        )
      }
    );
  }));
}
function ke({
  searchRecommendations: t,
  i18n: o,
  onClick: a,
  isSearchHistoryEmpty: r
}) {
  const { firstListBoxItemRef: s, lastListBoxItemRef: l, uuid: i } = C();
  return t.length === 0 ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    k,
    {
      uuid: i,
      variant: "heading",
      value: o?.searchRecommendations || "Give these searches a try"
    }
  ), t.slice(0, 5).map((c, n) => {
    const { value: h } = I(c);
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      k,
      {
        uuid: i + n,
        key: h,
        option: c,
        variant: "recommendation",
        onClick: a,
        ref: (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(
          r && n === 0 ? s : void 0,
          l
        )
      }
    );
  }));
}
const Me = [
  " ",
  // space
  "Backspace".toLowerCase(),
  ..."abcdefghijklmnopqrstuvwxyzäö0123456789".split("")
];
function De() {
  const t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(-1), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), {
    listBoxRef: a,
    searchRef: r,
    firstListBoxItemRef: s,
    lastListBoxItemRef: l,
    searchValue: i
  } = C();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    t.current = -1;
  }, [i]);
  const c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore)(
    Pe,
    $e,
    () => null
  );
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (c === s.current && (t.current = 0), c === l.current) {
      const n = oe(a.current), h = Math.max(n?.length || 0, 0);
      t.current = h - 1;
    }
  }, [c, s, l, a]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (n) => {
      const h = oe(a.current), d = h?.length || 0, u = t.current;
      if (d === 0)
        return;
      if (Me.includes(n.key.toLowerCase()))
        return r.current?.focus();
      const p = (L) => {
        o.current = !0, t.current = Math.min(Math.max(0, L), d - 1), h?.item(t.current)?.focus();
      }, y = () => p(0), m = () => p(d - 1), b = () => p((u + 1) % d), j = () => p(u <= 0 ? d - 1 : u - 1);
      switch (n.key) {
        case "Tab":
          return n.preventDefault(), n.shiftKey ? u === 0 ? r.current?.focus() : j() : b();
        case "ArrowDown":
          return n.preventDefault(), n.metaKey ? m() : b();
        case "ArrowUp":
          return n.preventDefault(), n.metaKey ? y() : j();
      }
    },
    [a, r]
  );
}
function Pe(t) {
  return window.addEventListener("focusin", t), () => window.removeEventListener("focusin", t);
}
function $e() {
  return window.document.activeElement;
}
function ze({
  isOpen: t,
  searchHistory: o,
  searchRecommendations: a,
  searchAutocompleteSuggestion: r,
  i18n: s,
  changeSearchValue: l,
  onSearchRecommendationClick: i,
  closeListBox: c
}, n) {
  const { uuid: h, searchValue: d, isNewJobsHeader: u } = C(), p = d.trim().length === 0, y = ee(h), m = De(), b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (L) => l(L, !0),
    [l]
  ), j = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (L) => {
      i ? (c(), i(L)) : b(L);
    },
    [c, b, i]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      ...y("list"),
      ref: n,
      className: v.typeAheadListBox,
      role: "listbox",
      "data-open": t,
      onKeyDown: m,
      tabIndex: 0
    },
    p ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, !u && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      Re,
      {
        searchHistory: o,
        i18n: s,
        onClick: b
      }
    ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      ke,
      {
        searchRecommendations: a,
        i18n: s,
        isSearchHistoryEmpty: o.length === 0,
        onClick: j
      }
    )) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      We,
      {
        i18n: s,
        changeSearchValue: l,
        autocompleteSuggestions: r
      }
    )
  );
}
const Ke = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ze);
function Ve(t, o, a) {
  const [r, s] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    s(!0), a?.(!0);
  }, [a]), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    s(!1), a?.(!1);
  }, [a]);
  return (0,_useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_4__.b)([o, t], i, {
    disabled: !r
  }), { isListBoxOpen: r, openListBox: l, closeListBox: i };
}
function de({
  defaultValue: t = "",
  searchHistory: o = [],
  searchRecommendations: a = [],
  searchAutocompleteSuggestion: r = [],
  placeholder: s,
  i18n: l,
  onSearch: i,
  onSearchListBoxOpenChange: c,
  onSearchRecommendationClick: n,
  onClear: h,
  onCurrentWordChange: d,
  isNewJobsHeader: u,
  isLoading: p,
  inputId: y,
  labelId: m
}) {
  const b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)(), j = y || `${b}-search`, L = l?.searchLabel || "Search jobs", H = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), W = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), $ = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), z = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), [g, K] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(t), { isListBoxOpen: M, openListBox: w, closeListBox: _ } = Ve(
    W,
    H,
    c
  );
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    K(t);
  }, [t]);
  const T = (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_2__.a)((F) => {
    i(F), _(), H.current?.blur();
  }), V = (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_2__.a)(() => {
    (!g || !g.endsWith(" ")) && w();
  }), U = (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_2__.a)(() => {
    g || w();
  }), q = (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_2__.a)(
    (F, he = !1) => {
      const { label: te, value: se } = I(F);
      K(te), te.endsWith(" ") ? (_(), T(se)) : w(), he ? T(se) : H.current?.focus();
    }
  ), G = (0,_index_615eb227_mjs__WEBPACK_IMPORTED_MODULE_2__.a)(
    (F) => {
      switch (F.key) {
        case "Enter":
          return T(F.currentTarget.value);
        case "ArrowDown":
          return F.preventDefault(), w(), $.current?.focus();
        case "ArrowUp":
          return F.preventDefault(), w(), z.current?.focus();
      }
    }
  ), me = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (u)
      return g;
    const F = g.split(" ");
    return F[F.length - 1]?.trim();
  }, [g, u]), X = (0,react__WEBPACK_IMPORTED_MODULE_0__.useDeferredValue)(me);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    d?.(X);
  }, [X, d]), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    ce.Provider,
    {
      value: {
        searchRef: H,
        listBoxRef: W,
        firstListBoxItemRef: $,
        lastListBoxItemRef: z,
        searchValue: g,
        isListBoxOpen: M,
        currentWord: X,
        uuid: b,
        isNewJobsHeader: u,
        isLoading: p
      }
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { "data-testid": "type-ahead", className: v.typeAhead }, m ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", { htmlFor: j, className: v.visuallyHidden }, L), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      Se,
      {
        ref: H,
        id: j,
        "aria-labelledby": m,
        name: "jobs-search",
        value: g,
        placeholder: s || (u ? "Job title" : "Job title, company or location"),
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(v.typeAheadInput, _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsLeadText),
        onChange: q,
        onKeyDown: G,
        onClick: V,
        onFocus: U,
        onClear: h
      }
    ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      Ke,
      {
        ref: W,
        isOpen: M,
        searchHistory: o,
        searchRecommendations: u ? [] : a,
        searchAutocompleteSuggestion: r,
        i18n: l,
        changeSearchValue: q,
        onSearchRecommendationClick: n,
        closeListBox: _
      }
    ))
  );
}
const Ue = "jobs-header", qe = "jobs-header__content", Ge = "desktop", Je = "jobs-header--with-filters", Qe = "jobs-header__with-filters-top", Xe = "jobs-header__with-filters-copy", Ye = "jobs-header__with-filters-heading", Ze = "jobs-header__with-filters-lead", et = "jobs-header__with-filters-toggle", tt = "jobs-header__with-filters-row", st = "jobs-filters-field", at = "jobs-header__reset", nt = "jobs-header__mobile-overlay", ot = "jobs-filters-field-label", rt = "jobs-header__mobile-overlay-header", lt = "jobs-header__mobile-overlay-title", it = "jobs-header__mobile-close", ct = "jobs-header__mobile-close-icon", dt = "jobs-header__mobile-overlay-body", f = {
  jobsHeader: Ue,
  jobsHeaderContent: qe,
  desktop: Ge,
  jobsHeaderWithFilters: Je,
  jobsHeaderWithFiltersTop: Qe,
  jobsHeaderWithFiltersCopy: Xe,
  jobsHeaderWithFiltersHeading: Ye,
  jobsHeaderWithFiltersLead: Ze,
  jobsHeaderWithFiltersToggle: et,
  jobsHeaderWithFiltersRow: tt,
  jobsFiltersField: st,
  jobsHeaderReset: at,
  jobsHeaderMobileOverlay: nt,
  jobsFiltersFieldLabel: ot,
  jobsHeaderMobileOverlayHeader: rt,
  jobsHeaderMobileOverlayTitle: lt,
  jobsHeaderMobileClose: it,
  jobsHeaderMobileCloseIcon: ct,
  jobsHeaderMobileOverlayBody: dt
}, ut = "jobs-filters", mt = "jobs-filters--singleton", ht = "jobs-filters__hidden-field", bt = "jobs-filters--with-filters", P = {
  jobsFilters: ut,
  jobsFiltersSingleton: mt,
  jobsFiltersHiddenField: ht,
  jobsFiltersWithFilters: bt
};
function re(t) {
  return t.reduce((o, a) => o + (a.count ?? 0), 0);
}
function ue({
  categories: t,
  cities: o,
  i18n: a,
  onFilterOpenChange: r,
  isNewJobsHeader: s,
  isDisabled: l,
  layout: i = "default"
}) {
  const c = i === "with-filters", [n, h] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), [d, u] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1);
  if ((0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(
    () => r?.(n || d),
    [r, n, d]
  ), !(t.items.length > 0 || o.items.length > 0))
    return null;
  const y = a.category || (s ? "Function" : "Category"), m = a.city || (s ? "Location" : "City");
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      "data-testid": "jobs-filters",
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        P.jobsFilters,
        c && P.jobsFiltersWithFilters,
        !c && (n || d) && P.jobsFiltersSingleton
      )
    },
    t.items.length > 0 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Dropdown_cd8b285a_mjs__WEBPACK_IMPORTED_MODULE_5__.D,
      {
        "data-testid": "jobs-filter-categories",
        label: c ? `${y} (${re(t.items)})` : y,
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
          !c && d && P.jobsFiltersHiddenField
        ),
        onOpenStateChange: h,
        ...t,
        ...s ? { disabled: l } : {}
      }
    ),
    o.items.length > 0 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Dropdown_cd8b285a_mjs__WEBPACK_IMPORTED_MODULE_5__.D,
      {
        "data-testid": "jobs-filter-cities",
        label: c ? `${m} (${re(o.items)})` : m,
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
          !c && n && P.jobsFiltersHiddenField
        ),
        onOpenStateChange: u,
        ...o,
        emptyMessage: s ? "No locations found" : void 0,
        showFilterInput: !0,
        ...s ? { disabled: l } : {}
      }
    )
  );
}
function ft(t) {
  return window.addEventListener("resize", t), () => window.removeEventListener("resize", t);
}
function pt({
  id: t,
  heading: o,
  leadText: a,
  onDropdownOpenChange: r,
  i18n: s = {},
  search: l,
  categories: i,
  cities: c,
  isNewJobsHeader: n,
  isLoading: h
}) {
  const [d, u] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), [p, y] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(
    () => r?.(d || p),
    [r, d, p]
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _PageHeader_js__WEBPACK_IMPORTED_MODULE_6__/* .PageHeader */ .m,
    {
      id: t,
      heading: o,
      leadText: a,
      bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_7__.B.Padding.NONE,
      "data-testid": "jobs-header",
      backgroundColor: "blue",
      className: f.jobsHeader
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: f.jobsHeaderContent }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      de,
      {
        ...l,
        onSearchListBoxOpenChange: u,
        i18n: s,
        isNewJobsHeader: n,
        isLoading: h
      }
    ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      ue,
      {
        categories: i,
        cities: c,
        onFilterOpenChange: y,
        i18n: s,
        isNewJobsHeader: n,
        isDisabled: l?.searchAutocompleteSuggestion?.length === 0
      }
    ))
  );
}
function yt({
  id: t,
  heading: o,
  leadText: a,
  onDropdownOpenChange: r,
  i18n: s = {},
  search: l,
  categories: i,
  cities: c,
  isNewJobsHeader: n,
  isLoading: h,
  filtersVisible: d = !0,
  onToggleFilters: u,
  onResetFilters: p,
  totalJobs: y = 0
}) {
  const [m, b] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), [j, L] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), W = (0,react__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore)(
    ft,
    () => window.innerWidth,
    () => 0
  ) < _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.D.md;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(
    () => r?.(m || j),
    [r, m, j]
  );
  const $ = s.showFilters || "Show filters", z = s.hideFilters || "Hide filters", g = s.resetFilters || "Reset filters", K = s.showJobs || `Show jobs (${y})`, M = s.filtersTitle || "Filters", w = s.close || "Close", _ = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)(), T = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)(), V = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    de,
    {
      ...l,
      inputId: _,
      labelId: s.searchLabel ? T : void 0,
      onSearchListBoxOpenChange: b,
      i18n: s,
      isNewJobsHeader: n,
      isLoading: h
    }
  ), U = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    ue,
    {
      categories: i,
      cities: c,
      onFilterOpenChange: L,
      i18n: s,
      isNewJobsHeader: n,
      isDisabled: l?.searchAutocompleteSuggestion?.length === 0,
      layout: "with-filters"
    }
  ), q = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_8__.B.Secondary,
    {
      text: d ? z : $,
      icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__.W.FILTER,
      iconPosition: "left",
      onClick: u,
      "data-testid": "jobs-header-toggle-filters"
    }
  ), G = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      type: "button",
      className: f.jobsHeaderReset,
      onClick: p,
      "data-testid": "jobs-header-reset-filters"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__.I, { icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__.W.CLOSE, size: 16 }),
    g
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_7__.B,
    {
      id: t,
      "data-testid": "jobs-header",
      "data-layout": "with-filters",
      topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_7__.B.Padding.SMALL,
      bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_7__.B.Padding.NONE,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(f.jobsHeader, f.jobsHeaderWithFilters)
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_7__.B.Content, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: f.jobsHeaderWithFiltersTop }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: f.jobsHeaderWithFiltersCopy }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "h2",
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
          _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.pageHeading,
          f.jobsHeaderWithFiltersHeading
        )
      },
      o
    ), a && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "p",
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
          _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsComponentTitle,
          f.jobsHeaderWithFiltersLead
        )
      },
      a
    )), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: f.jobsHeaderWithFiltersToggle }, q))),
    d && !W && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_7__.B.Content, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: f.jobsHeaderWithFiltersRow,
        "data-testid": "jobs-header-filters"
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: f.jobsFiltersField }, s.searchLabel && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "label",
        {
          id: T,
          htmlFor: _,
          className: f.jobsFiltersFieldLabel
        },
        s.searchLabel
      ), V),
      U,
      G
    )),
    d && W && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: f.jobsHeaderMobileOverlay,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": M,
        "data-testid": "jobs-header-mobile-filters"
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: f.jobsHeaderMobileOverlayHeader }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "h2",
        {
          className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
            _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsComponentTitle,
            f.jobsHeaderMobileOverlayTitle
          )
        },
        M
      ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "button",
        {
          type: "button",
          className: f.jobsHeaderMobileClose,
          onClick: u
        },
        w,
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: f.jobsHeaderMobileCloseIcon }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__.I, { icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_3__.W.CLOSE, size: 20 }))
      )),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: f.jobsHeaderMobileOverlayBody }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: f.jobsFiltersField }, s.searchLabel && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "label",
        {
          id: T,
          htmlFor: _,
          className: f.jobsFiltersFieldLabel
        },
        s.searchLabel
      ), V), U, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_8__.B.Primary,
        {
          text: K,
          onClick: u,
          "data-testid": "jobs-header-show-jobs"
        }
      )),
      G
    )
  );
}
function Ct(t) {
  return t.layout === "with-filters" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(yt, { ...t }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(pt, { ...t });
}

//# sourceMappingURL=JobsHeader.js.map


/***/ }),

/***/ 9792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ E; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3406);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4877);



const i = "page-header", H = "page-header--blue", m = "page-header--light-blue", u = "page-header__heading", h = "desktop", B = "page-header__lead-text", t = {
  pageHeader: i,
  pageHeaderBlue: H,
  pageHeaderLightBlue: m,
  pageHeaderHeading: u,
  desktop: h,
  pageHeaderLeadText: B
};
function E({
  heading: n,
  leadText: r,
  backgroundColor: o,
  children: g,
  className: l,
  ...s
}) {
  const c = o === "lightBlue" ? t.pageHeaderLightBlue : t.pageHeaderBlue;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B,
    {
      "data-testid": "page-header",
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(t.pageHeader, c, l),
      topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.SMALL,
      ...s
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, { itemScope: !0 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("h1", { className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.pageHeading, t.pageHeaderHeading) }, n)),
    r && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, { itemScope: !0 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
          _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsComponentTitle,
          t.pageHeaderLeadText
        )
      },
      r
    )),
    g ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, null, g) : null
  );
}

//# sourceMappingURL=PageHeader.js.map


/***/ }),

/***/ 3403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ G; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3406);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4877);
/* harmony import */ var _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7977);






const w = "pagination", N = "pagination__items", S = "pagination__item", L = "pagination__item--selected", k = "pagination__caption", d = {
  pagination: w,
  paginationItems: N,
  paginationItem: S,
  paginationItemSelected: L,
  paginationCaption: k
};
function A(n) {
  const { value: t = 1, count: e, onChange: o } = n, a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), [i, m] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(P(t, e)), [, p] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useTransition)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => m(P(t, e)), [t, e]);
  const c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (l) => {
      const r = typeof l == "number" ? l : l(i), g = P(r, e);
      g !== i && (m(g), o && p(() => o(g)));
    },
    [i, o, e]
  ), f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (l) => {
      switch (l.key) {
        case "ArrowRight":
          return a.current?.focus(), c((r) => r + 1);
        case "ArrowLeft":
          return a.current?.focus(), c((r) => r - 1);
      }
    },
    [c]
  ), b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => D(i, e), [i, e]);
  return { page: i, handlePageChange: c, itemList: b, handleKeyDown: f, containerRef: a };
}
function P(n, t) {
  return Math.max(Math.min(n, t), 1);
}
function D(n, t, e = 1, o = 5) {
  const a = "...";
  return t === 1 ? [e] : t === 2 ? [e, t] : t <= o ? Array(t).fill(0).map((i, m) => m + 1) : n <= 2 ? [e, e + 1, e + 2, a, t] : n >= t - 1 ? [e, a, t - 2, t - 1, t] : [e, a, n, a, t];
}
function G(n) {
  const { i18n: t = {}, count: e, caption: o } = n, {
    btnNextText: a = "Next page",
    btnPrevText: i = "Previous page",
    btnPageText: m = "Go to page"
  } = t, { page: p, handlePageChange: c, itemList: f, handleKeyDown: b, containerRef: l } = A(n);
  return !e || e === 0 ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B, { topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.NONE, bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.SMALL }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: d.pagination,
      "data-testid": "pagination",
      onKeyDown: b,
      tabIndex: -1,
      ref: l
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Arrow,
      {
        arrowDirection: "left",
        "data-testid": "pagination-prev",
        "aria-label": i,
        title: i,
        disabled: p === 1,
        onClick: () => c((r) => r - 1)
      }
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", { className: d.paginationItems, "data-testid": "pagination-items" }, f.map((r, g) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", { key: g }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      R,
      {
        page: r,
        selectedPage: p,
        onSelect: c,
        title: m
      }
    )))),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Arrow,
      {
        arrowDirection: "right",
        "data-testid": "pagination-next",
        "aria-label": a,
        title: a,
        disabled: p === e,
        onClick: () => c((r) => r + 1)
      }
    )
  ), o && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "p",
    {
      className: d.paginationCaption,
      "data-testid": "pagination-caption"
    },
    o
  )));
}
function R({
  page: n,
  selectedPage: t,
  onSelect: e,
  title: o
}) {
  const a = typeof n == "number", i = a && n === t;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      type: "button",
      "data-testid": "pagination-item-" + n,
      "aria-current": i ? "page" : void 0,
      "aria-label": a ? `${o} ${n}` : void 0,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_3__.c)(
        d.paginationItem,
        i && d.paginationItemSelected
      ),
      disabled: !a,
      onClick: () => a && e?.(n),
      title: a ? `${o} ${n}` : void 0
    },
    n
  );
}

//# sourceMappingURL=Pagination.js.map


/***/ })

}]);